import { BoqSectionsSection } from "./BoqSectionsSection";
import { FileInventorySection } from "./FileInventorySection";
import { PageTypesChart } from "./PageTypesChart";
import { ProjectOverviewSidebar } from "./ProjectOverviewSidebar";
import { ScopeSummarySection } from "./ScopeSummarySection";
import { SurveyorAlertsSection } from "./SurveyorAlertsSection";
import { ZoneCardsSection } from "./ZoneCardsSection";
import type { ResearchReportData } from "./types";

export const OverviewTab = ({
  report,
  onNavigate,
}: {
  report: ResearchReportData;
  onNavigate: (file: string, page: number) => void;
}) => {
  return (
    <div className="flex overflow-hidden flex-1 min-h-0">
      {/* Left sidebar */}
      <div className="w-96 shrink-0 border-r border-gray-200 bg-white overflow-y-auto p-6 space-y-5">
        <ProjectOverviewSidebar report={report} />
        <PageTypesChart pageTypeSummary={report.page_type_summary} />
      </div>

      {/* Main scrollable area */}
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <SurveyorAlertsSection alerts={report.surveyor_alerts} />
        <ScopeSummarySection
          summary={report.scope_summary}
          onNavigate={onNavigate}
        />
        <BoqSectionsSection
          sections={report.boq_sections}
          totalPositions={report.boq_total_positions}
          onNavigate={onNavigate}
        />
        <FileInventorySection files={report.file_names} />
        <ZoneCardsSection zones={report.zones} />
      </div>
    </div>
  );
};
